import PropTypes from 'prop-types';

export const IDLE = 'idle';
export const PENDING = 'pending';
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';
export const asyncLoadingStatusTypes = PropTypes.oneOf([
  IDLE, PENDING, SUCCEEDED, FAILED,
]);
export const isAsyncUnresovled = (status) => status === IDLE || status === PENDING;
